import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { for: "fileselect" }

import {UploaderI18n} from "../types/I18n";
    import {UploadFile} from "../types/UploadFile";
    import { type PropType } from 'vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LocalFilePicker',
  props: {
        i18n: {
            type: Object as PropType<UploaderI18n>,
            required: true
        },
        doResize: Boolean
    },
  emits: ['addFileCallback'],
  setup(__props, { emit: __emit }) {

    const props = __props

    const emit = __emit

    const addFiles = (event: InputEvent) => {
        const target = event.target as HTMLInputElement
        let newFiles = target.files || event.dataTransfer.files;
        for (let i = 0; i<newFiles.length; i++) {
            let uploadFile : UploadFile  =  {
                localFile: newFiles[i],
                name: newFiles[i].name,
                doResize: props.doResize
            }
            emit('addFileCallback', uploadFile);
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_FILES_TO_UPLOAD) + ":", 1 /* TEXT */),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _createElementVNode("input", {
      id: "fileselect",
      type: "file",
      multiple: "multiple",
      onChange: addFiles
    }, null, 32 /* NEED_HYDRATION */)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})